import { Calendar } from '@fullcalendar/core';
import lvLocale from '@fullcalendar/core/locales/lv';
import dayGridPlugin from '@fullcalendar/daygrid';

// Main data source
import googleCalendarPlugin  from '@fullcalendar/google-calendar';

document.addEventListener('DOMContentLoaded', function() {
  var calendarEl = document.getElementById('full-calendar');

  var calendar = new Calendar(calendarEl, {
    locale: lvLocale,
    plugins: [ dayGridPlugin, googleCalendarPlugin ],
    defaultView: 'dayGridMonth',
    weekNumbers: true,
    header: {
        left:   'prev,next today',
        center: 'title',
        right:  'dayGridWeek,dayGridMonth'
    },
    googleCalendarApiKey: 'AIzaSyCF_RD6GOIDh70Eg68MBbTXubL1kEmrx5Q',
    eventSources: [
        {
            googleCalendarId: 'lkmqpoa39ocrgap4u767r5gj7o@group.calendar.google.com',
            className: 'dezuras',
            id: 'dezuras',
            name: "S! Krustdēlu dežūras"
        },
        {
            googleCalendarId: 'h2lgqj5fggdhtl0ii1m5d71doo@group.calendar.google.com',
            className: 'pasakumi',
            id: 'pasakumi',
            name: "S! Pasākumi"
        },
        {
            googleCalendarId: 'lv.latvian#holiday@group.v.calendar.google.com',
            className: 'brivdienas',
            id: 'brivdienas',
            color: '#e67c73',
            textColor: 'white'  
        },
    ],
    eventRender: function(info) {
        if (info.event.allDay) {
           info.el.classList.add("fce-all-day-event");
        } else {
            info.el.classList.add("fce-timed-event");
        }

        $(info.el).tooltip({
            title: info.event.title,
            placement: 'top',
            container: '#full-calendar',
            trigger: 'hover'
        });
     },
     eventDestroy: function(info){
        $(info.el).popover('destroy');
     },
     eventClick: function(info){
        info.jsEvent.preventDefault(); // don't let the browser navigate
     }
  });

  calendar.render();

    // $('body').click(function(event){
        // if( !$(event.target).parents('.popover').length ){
            // $('.fc-event').popover('toggle');
            // $('.fc-event').not(event.target).popover('hide');
        // }
        //   console.log(this);
    // });
});